<template>
    <div id="contenedor-main-listado-obras">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop
              :listadoLicitaciones="listadoLicitaciones"
              :cargando="cargando"
              :server-items-length="serverItemsLength"
              :options.sync="optionsSync">
            </desktop>
        </template>
        <template
            v-else>
            <mobile
              :listadoLicitaciones="listadoLicitaciones"
              :cargando="cargando">
            </mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoObras',
  props: {
    listadoLicitaciones: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
    serverItemsLength: {
      type: Number,
      default: 0,
    },
    options: {
      type: Object,
      default: () => ({
        page: 1,
        itemsPerPage: 20,
      }),
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
  computed: {
    optionsSync: {
      get() {
        return this.options;
      },
      set(value) {
        this.$emit('update:options', value);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
